// BranchOfficeEnvironments.js
import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class BranchOfficeEnvironmentsFetchAPI {

    //Get all environments of a branch office
    static async getBranchofficeEnvironments(branchoffice_id, token) {
        const res = await server(`/branchoffice/${branchoffice_id}/environments`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }
    // Create a new environment for a branch office
    static async createBranchofficeEnvironment(data, branchoffice_id, token) {
        const res = await server(`/branchoffice/${branchoffice_id}/environments`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }
    // Assign tables to an environment
    static async assignTablesToEnvironment(data, branchoffice_environment_id, token) {
        const res = await server(`/branchoffice/environment/${branchoffice_environment_id}/tables`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }
    //Get branchoffice enviroment details
    static async getBranchofficeEnvironmentDetails(branchoffice_environment_id, token) {
        const res = await server(`/branchoffice/environment/${branchoffice_environment_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }
    //Update branchoffice environment details
    static async updateBranchofficeEnvironmentDetails(data, branchoffice_environment_id, token) {
        const res = await server(`/branchoffice/environment/${branchoffice_environment_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Delete branchoffice environment
    static async deleteBranchofficeEnvironment(branchoffice_environment_id, token) {
        const res = await server(`/branchoffice/environment/${branchoffice_environment_id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res
    }
};
